"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _actions = require("../actions");

var _handleActions;

var initialState = null;

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(_actions.FetchMeetingsUserActionTypes.SUCCESS, _actions.CreateMeetingsUserActionTypes.SUCCESS), function (userToEdit, action) {
  return action.payload.data;
}), (0, _defineProperty2.default)(_handleActions, _actions.SaveMeetingsUserActionTypes.SUCCESS, function (userToEdit, action) {
  return userToEdit.set('namespace', action.payload.data.namespace).set('calendarEmail', action.payload.data.calendarEmail).set('defaultLinkId', action.payload.props.stagedDefaultLinkId).set('calendarIdsToCheck', action.payload.data.calendarIdsToCheck).set('calendarIdToWriteTo', action.payload.data.calendarIdToWriteTo).set('calendarDisplayNames', action.payload.data.calendarDisplayNames).set('customHostedDomain', action.payload.data.customHostedDomain);
}), (0, _defineProperty2.default)(_handleActions, _actions.UpdateMeetingsUserIntegrationActionTypes.SUCCESS, function (userToEdit, action) {
  return userToEdit.set('namespace', action.payload.data.namespace).set('calendarEmail', action.payload.data.calendarEmail).set('calendarIdsToCheck', action.payload.data.calendarIdsToCheck).set('calendarIdToWriteTo', action.payload.data.calendarIdToWriteTo).set('calendarDisplayNames', action.payload.data.calendarDisplayNames);
}), (0, _defineProperty2.default)(_handleActions, _actions.VerifyCalendarsActionTypes.SUCCESS, function (userToEdit, action) {
  return userToEdit.setUnavailableCalendarIds(action.payload.data);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchPrimaryCalendarActionTypes.SUCCESS, function (userToEdit, action) {
  var email = userToEdit.get('calendarEmail');
  var primaryCalendarId = action.payload.data.getIn([email, 'id']);
  return userToEdit.setIn(['calendarIdsToCheck', primaryCalendarId], true).set('calendarIdToWriteTo', primaryCalendarId);
}), (0, _defineProperty2.default)(_handleActions, _actions.DisconnectMeetingsUserActionTypes.SUCCESS, function () {
  return initialState;
}), (0, _defineProperty2.default)(_handleActions, _actions.MeetingsActionTypes.SELECT_CALENDAR_INTEGRATION, function (userToEdit, action) {
  return userToEdit.set('calendarIntegrationChoice', action.integrationChoice);
}), (0, _defineProperty2.default)(_handleActions, _actions.MeetingsActionTypes.SET_AUTHED_EMAIL, function (userToEdit, action) {
  if (!userToEdit.get('calendarEmail') || userToEdit.get('calendarEmail') !== action.authedEmail) {
    return userToEdit.set('calendarEmail', action.authedEmail);
  }

  return userToEdit;
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;